export default __webpack_public_path__ + "static/media/distractions6.46ab2812.png";